import type * as MediaSessionBundle from '@foundation-player/plugin-media-session';
import { PluginFactoryFunction } from '../builder-config';
import { PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createMediaSessionPlugin: PluginFactoryFunction = () => {
  const mediaSessionPackage = PackageName.PluginMediaSession;

  return [
    [mediaSessionPackage],
    () => {
      const bundle = resolveByPackageNameOrThrow<typeof MediaSessionBundle>(mediaSessionPackage);
      return [new bundle.MediaSessionPlugin()];
    },
  ];
};
